import * as React from "react";

const SvgCursorsMove = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillOpacity={0.92}
      fillRule="evenodd"
      d="M14.506 8.245h1.252v1.252h-1.252zm1.252 7.513h-1.252v-1.252h1.252zM9.496 9.497H8.243V8.245h1.253zm0 6.26H8.243v-1.251h1.253zM12 2 2 12.003l6.54 6.537L12 22l10-9.999z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.225 11.997 17.022 8.48v2.29H6.99V8.48l-3.22 3.517 3.221 3.516V13.25h10.031l-.001 2.264z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.237 12.001h.016v-5.01l2.264.001L12 3.773 8.483 6.991h2.265v5.01h.01v5.012L8.47 17.01l3.516 3.227 3.513-3.226h-2.26z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCursorsMove;
